import logo from '../../logo.svg';
import './Menu.css';
import React, { useRef, useEffect } from 'react';

function Menu() {

    const navbarCollapseRef = useRef(null);

    const handleToggleClick = () => {
        if (navbarCollapseRef.current) {
            navbarCollapseRef.current.classList.toggle('show');
        }
    };

    const handleLinkClick = () => {
        if (navbarCollapseRef.current) {
            navbarCollapseRef.current.classList.remove('show');
        }
    };

useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add("fade-in");
            }
        });
    }, { threshold: 0.1 });

    // Observamos os elementos do menu, incluindo a logo e o botão hambúrguer
    document.querySelectorAll(".logo-ba, .nav-link, .btn-contatar, .navbar-toggler").forEach((el) => observer.observe(el));

    return () => observer.disconnect();
}, []);

    return (
        <div className="">
            <header className="App-header">
                <nav class="navbar navbar-expand-lg ">
                    <a class="navbar-brand" href="#">
                        <img src={logo} className='logo-ba' alt='Logo Blue Análises' />
                    </a>
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Alternar navegação" >
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarNav" ref={navbarCollapseRef}>
                        <ul class="navbar-nav ms-auto">
                            <li className="nav-item">
                                <a class="nav-link" href="#" onClick={handleLinkClick} aria-label="Ir para a Home">Home</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#sobre" onClick={handleLinkClick} aria-label="Ir para a seção Sobre">Sobre nós</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#servicos" onClick={handleLinkClick} aria-label="Ir para a seção Serviços">Serviços</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#clientes" onClick={handleLinkClick} aria-label="Ir para a seção Clientes">Clientes</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link btn-contatar" href="https://wa.me/553233210063?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20quero%20saber%20mais%20informa%C3%A7%C3%B5es%20sobre%20os%20servi%C3%A7os%20da%20Blue%20An%C3%A1lises%20e%20Servi%C3%A7os%20Ambientais." onClick={handleLinkClick} aria-label="Ir para a seção Contatar">Contatar</a>
                            </li>
                        </ul>
                    </div>
                </nav>
            </header> 
        </div>
    );
}

export default Menu;